"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyRequestMiddleware = applyRequestMiddleware;
exports.default = _default;
const requestMiddleware = [];
function applyRequestMiddleware(fn) {
  requestMiddleware.push(fn);
}
function _default(url, options = {}) {
  requestMiddleware.forEach(fn => {
    fn(url, options);
  });
  return fetch(url, options);
}
//# sourceMappingURL=fetch.js.map